import { render, staticRenderFns } from "./ApproveDialog.vue?vue&type=template&id=01267d57&scoped=true&"
import script from "./ApproveDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApproveDialog.vue?vue&type=style&index=0&id=01267d57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01267d57",
  null
  
)

export default component.exports